/**
 * coco+ (application_id 145) のテーマカラー。
 * base = crimson-500(#E8173C)、グラデーションは crimson-600 → 500（白文字 4.5:1 を満たすため）。
 * 文字色はクリムゾンに寄せたダークワイン系、背景は淡いローズ系。
 */
import { tailwindScales as tw } from "../tailwindColors";
import type { ThemePalette } from "../types";

export const COCOPLUS_PALETTE: ThemePalette = {
  appId: "145",
  appName: "coco+",
  cyan: tw.crimson,
  teal: tw.crimson,
  gradient: { from: tw.crimson[600], to: tw.crimson[500] },
  ink: { base: "#2A0A12", soft: "#6E3A46", mute: "#8E6470" },
  app: { bg: "#FFF5F6", card: "#FFFFFF" },
};
